import AscendingLogoGrey from "assets/img/illustrations/AscendingLogoGrey";
import DescendingLogoGrey from "assets/img/illustrations/DescendingLogoGrey";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";

export const paginationData = (sortData, setCallData, setFilter, page) => {
  const numOfSubarrays = Math.max(Math.ceil((sortData?.length || 0) / 10), 0);

  const arrayOfArrays = sortData
    ? Array.from({ length: numOfSubarrays }, (_, i) => {
        const start = i * 10;
        const end = start + 10;
        return sortData?.slice(start, end);
      })
    : [];
  setCallData(Math.max(Math.ceil((sortData?.length || 0) / 10), 1));
  setFilter(arrayOfArrays[page - 1]);
};

export const ascendingHeader = (
  name,
  handleScheduleAt,
  order,
  schedule,
  setSchedule,
  sortQuery
) => {
  return (
    <OverlayTrigger
      overlay={
        <Tooltip style={{ position: "fixed" }} id="overlay-trigger-example">
          {order[schedule] == 0 ? (
            <span className="fw-bold">Click to cancel sort</span>
          ) : order[schedule] == 1 ? (
            <span className="fw-bold">Click to sort Ascending</span>
          ) : (
            <span className="fw-bold">Click to sort Descending</span>
          )}
        </Tooltip>
      }
    >
      <th
        style={{ background: "#EAF0FC", top: 0, position: "sticky" }}
        className="flex-1 align-top text-center fixed-width cursor-pointer"
        onClick={() => {
          const query = sortQuery(`${name}`, order[schedule]);
          handleScheduleAt(query);
          setSchedule(order[schedule]);
        }}
      >
        <span style={{ display: "inline-block", verticalAlign: "middle" }}>
          {name}
        </span>
        <div
          style={{
            display: "inline-block",
            verticalAlign: "middle",
            paddingLeft: "1rem",
          }}
        >
          <div
            className={
              order[schedule] == 0
                ? "opacity-100 mt-n2"
                : order[schedule] == 1
                ? "opacity-50 mt-n2"
                : "opacity-100 mt-n2"
            }
          >
            <AscendingLogoGrey />
          </div>
          <div
            className={
              order[schedule] == 0
                ? "opacity-100 mt-n2"
                : order[schedule] == -1
                ? "opacity-50 mt-n2"
                : "opacity-100 mt-n2"
            }
          >
            <DescendingLogoGrey />
          </div>
        </div>
      </th>
    </OverlayTrigger>
  );
};

export const headerOne = [
  "Temporary Agent Name",
  "Attempt Status",
  "Customer Name",
  "Gender"
];

export const headerTwo = [
  "Call Started",
  "Call Ended",
  "Call Duration",
  "Notes",
];

export const tableHeaderData = (arr) => {
  return arr.map((name) => {
    return (
      <th
        style={{
          minWidth: "12rem",
          background: "#EAF0FC",
          position: "sticky",
          top: 0,
        }}
        className="align-top text-center "
      >
        {name}
      </th>
    );
  });
};

export const ADMIN_REP_ACCESS = ["super_admin", "admin", "team_lead"];
